export default Object.freeze({
  KEY_USER_PROFILE: 'user-profile',
  KEY_TEXT_EN: 'text-en',
  KEY_TEXT_ES: 'text-es',
});
